import alergia from '@/repositories/conecta-sus/cadastro/sujeito-atencao/alergiaRepository'
import cidadao from '@/repositories/conecta-sus/cadastro/sujeito-atencao/cidadaoRepository'
import convenioMedico from '@/repositories/conecta-sus/cadastro/sujeito-atencao/convenioMedicoRepository'
import paciente from '@/repositories/conecta-sus/cadastro/sujeito-atencao/pacienteRepository'
import usuario from '@/repositories/conecta-sus/cadastro/sujeito-atencao/usuarioRepository'

export default baseUrl => {
    return {
        alergia: alergia(baseUrl),
        cidadao: cidadao(baseUrl),
        convenioMedico: convenioMedico(baseUrl),
        paciente: paciente(baseUrl),
        usuario: usuario(baseUrl),
    }
}